/**
 * Error display banner.
 */

import React from 'react';
import { MessageBar, MessageBarBody } from '@fluentui/react-components';

interface ErrorDisplayProps {
  message: string;
  onDismiss?: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message, onDismiss }) => (
  <MessageBar intent="error" style={{ marginBottom: 8 }}>
    <MessageBarBody>
      {message}
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            marginLeft: 8,
            textDecoration: 'underline',
            color: 'inherit',
          }}
        >
          Fermer
        </button>
      )}
    </MessageBarBody>
  </MessageBar>
);
